export default {
  meta: {
    title: '流程任务列表',
  },
};
